(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // 透明ヘッダーの初期化処理
  const transparentHeader = document.querySelector('[data-transparent-header="true"]');
  if (transparentHeader) {
    const scrollThreshold = parseInt(transparentHeader.getAttribute('data-scroll-threshold') || 100);
    
    // 初期表示時の状態設定 - 最初から透明になるよう強制的に設定
    if (window.scrollY <= scrollThreshold) {
      transparentHeader.classList.remove('scrolled');
      transparentHeader.style.backgroundColor = 'transparent';
    } else {
      transparentHeader.classList.add('scrolled');
    }
    
    // スクロールイベント処理
    function handleScroll() {
      if (window.scrollY > scrollThreshold) {
        transparentHeader.classList.add('scrolled');
      } else {
        transparentHeader.classList.remove('scrolled');
      }
    }
    
    // スペーサーの高さを設定
    function updateHeaderHeight() {
      const header = document.querySelector('.header');
      const spacer = document.querySelector('.transparent-header-spacer');
      if (header && spacer) {
        const headerHeight = header.offsetHeight;
        spacer.style.height = headerHeight + 'px';
        document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
      }
    }
    
    // スクロールイベントをリッスン
    window.addEventListener('scroll', handleScroll, {passive: true});
    
    // リサイズ時にヘッダー高さを再計算
    window.addEventListener('resize', updateHeaderHeight);
    
    // 初期化時にヘッダー高さを計算
    updateHeaderHeight();
    
    // 画像読み込み完了後に再計算（ロゴの遅延読み込みによる高さ変化に対応）
    window.addEventListener('load', updateHeaderHeight);
  }
});

// StickyHeader クラス定義
class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      
      // 透明ヘッダー関連の設定 - 専用のスクリプトに移行したため簡略化
      this.isTransparentHeader = this.getAttribute('data-transparent-header') === 'true';

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-study"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const section = document.querySelector('.information-section');
  
  if (!section) return;
  
  const articles = section.querySelectorAll('.information-section__article');
  
  articles.forEach(article => {
    article.addEventListener('mouseenter', function() {
      this.style.transform = 'translateY(-5px)';
    });
    
    article.addEventListener('mouseleave', function() {
      this.style.transform = 'translateY(0)';
    });
  });
  
  // Ensure mobile layout works correctly
  const checkMobileLayout = function() {
    if (window.innerWidth <= 768) {
      const smallArticlesContainer = section.querySelector('.information-section__small-articles');
      if (smallArticlesContainer) {
        // Force grid layout
        smallArticlesContainer.style.display = 'grid';
        smallArticlesContainer.style.gridTemplateColumns = '1fr 1fr';
      }
    }
  };
  
  // Run on load and resize
  checkMobileLayout();
  window.addEventListener('resize', checkMobileLayout);
  
  // Make hashtag links work properly on mobile
  const allLinks = section.querySelectorAll('.information-section__link');
  allLinks.forEach(link => {
    link.addEventListener('touchend', function(e) {
      if (this.getAttribute('href') === '#') {
        e.preventDefault();
      }
    });
  });
  
  // Ensure images load properly
  const allImages = section.querySelectorAll('.information-section__article-image');
  allImages.forEach(img => {
    img.addEventListener('error', function() {
      this.src = '{{ "placeholder-image.jpg" | asset_url }}';
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
